import { ChangeEvent, FC, useCallback } from 'react';
import useUserSettings from '@/hooks/use-user-settings.hook';
import PreferenceControl from './preference-control';

interface Props {
  inline?: boolean;
}

const TailControl: FC<Props> = ({ inline }) => {
  const {
    preferences: { tail },
    patchPreferences,
  } = useUserSettings();

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      patchPreferences({ tail: event.target.checked });
    },
    [patchPreferences]
  );

  return (
    <PreferenceControl
      label="Scroll to bottom"
      checked={tail}
      onChange={handleChange}
      tooltip="Whether or not the window scrolls to the bottom when new messages arrive."
      inline={inline}
    />
  );
};

export default TailControl;
